class TabElement extends HTMLElement {
  constructor() {
    super()

    this.tabs = [...this.querySelectorAll('.js-tab')]
    this.tabList = this.querySelector('.js-tablist')
    this.tabPanels = [...this.querySelectorAll('.js-tabpanel')]
    this.mobileOnly = this.dataset.mobileOnly

    if (this.tabPanels[0]) this.showTabPanel(this.tabPanels[0], false)

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.activeTabPanel)
    })

    this.tabList.addEventListener('keydown', (e) => {
      this.onKeydown(e)
    })

    window.addEventListener('resize', () => {
      if (this.mobileOnly) this.resizeFunction()
      const activeTab = this.querySelector('.js-tabpanel.active')
      if (activeTab) this.adjustActiveTab(activeTab)
    })

    if (this.mobileOnly) this.resizeFunction()
  }

  adjustActiveTab = (activeTab) => {
    const contentGroup = activeTab.closest('.js-tabcontent')
    if (contentGroup) {
      const tabHeight = activeTab.offsetHeight
      contentGroup.style.height = `${tabHeight}px`
    }
  }

  showTabPanel = (tabPanelToOpen, isFocus=true) => {
    // open selected tab and set focus on content so user bypasses other tabs
    tabPanelToOpen.classList.add('active')
    tabPanelToOpen.setAttribute('tabindex', -1)
    tabPanelToOpen.setAttribute('aria-hidden', false)
    if (isFocus) tabPanelToOpen.focus()
    this.adjustActiveTab(tabPanelToOpen)
  }

  activeTabPanel = () => {
    var target = event.target

    // close any open tabs and reset tab button
    this.tabPanels.forEach((tabPanel) => {
      tabPanel.classList.remove('active')
      tabPanel.removeAttribute('tabindex')
      tabPanel.setAttribute('aria-hidden', true)
    })

    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false')
      tab.classList.remove('active')
    })

    // find panel to open through the aria-controls of the clicked tab button
    this.showTabPanel(document.getElementById(
      target.getAttribute('aria-controls')
    ))

    // highlight open tab button and update aria
    target.setAttribute('aria-selected', 'true')
    target.classList.add('active')
  }

  onKeydown = (e) => {
    if (e.keyCode === 39 || e.keyCode === 37) {
      var selected = document.activeElement

      // move right on right arrow
      if (e.keyCode === 39) {
        if (selected.nextElementSibling) {
          selected.nextElementSibling.click()
          selected.nextElementSibling.focus()
        }

        // move left on left arrow
      } else if (e.keyCode === 37) {
        if (selected.previousElementSibling) {
          selected.previousElementSibling.click()
          selected.previousElementSibling.focus()
        }
      }
    }
  }

  resizeFunction = () => {
    const mobile = window.matchMedia('(max-width: 989px)').matches

    // On desktop, hide the tab triggers, since they're redundant - all tab panels are visible. On mobile, add the event trigger
    mobile
      ? (this.tabList.classList.remove('hidden'),
        this.tabList.setAttribute('aria-hidden', false))
      : (this.tabList.classList.add('hidden'),
        this.tabList.setAttribute('aria-hidden', true))

    // On desktop, show all tab panels and remove aria attributes. On mobile, hide all tab panels and then show the first one, and add back aria attributes
    this.tabPanels.forEach((tabPanel, i) => {
      const tabId = tabPanel.id.split('-')[0]
      mobile
        ? (tabPanel.classList.add('hidden'),
          tabPanel.setAttribute('aria-hidden', true),
          i == 0 && tabPanel.classList.remove('hidden'),
          i == 0 && tabPanel.setAttribute('aria-hidden', false),
          tabPanel.setAttribute('role', 'tabpanel'),
          tabPanel.setAttribute('aria-labelledby', `${tabId}-tab`))
        : (tabPanel.classList.remove('hidden'),
          tabPanel.setAttribute('aria-hidden', false),
          tabPanel.removeAttribute('role'),
          tabPanel.removeAttribute('aria-labelledby'))
    })

    // The tab triggers are hidden on desktop, so nothing needs to happen. On mobile, hide all tab triggers and then show the first one
    this.tabs.forEach((tab, i) => {
      if (mobile) {
        tab.classList.remove('active')
        i == 0 && tab.classList.add('active')
      }
    })
  }
}

customElements.define('tab-element', TabElement)
